var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ethnic-background-template',{attrs:{"ethnicity":_vm.ethnicity,"other-ethnicity":_vm.otherEthnicity,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }